import { render } from "./foodDisplay.vue?vue&type=template&id=bb849f9c"
import script from "./foodDisplay.vue?vue&type=script&lang=js"
export * from "./foodDisplay.vue?vue&type=script&lang=js"

import "./foodDisplay.vue?vue&type=style&index=0&id=bb849f9c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__